import { ApiServerService } from '../../core/api';
import { PickupPointExtended } from './pickup-point.models';

export const getPoints = (service: ApiServerService, data: GetPointsRequest = null): Promise<PickupPointExtended[]> => {
  const path = `shipping/getPickupPoints`;
  return service.call<PickupPointExtended[], GetPointsRequest>(path, data);
};

export interface GetPointsRequest {
  coords: { lat: number; lng: number; };
  shippingType: string;
  currentWeightKg: number;
}

